import script from "./MembershipCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipCard.vue?vue&type=script&setup=true&lang=js"

import "./MembershipCard.vue?vue&type=style&index=0&id=47843fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47843fac"]])

export default __exports__